/** Demo funnel events → dataLayer (only reaches GA4 if the visitor consented and GTM loaded). */
type Event = 'demo_start' | 'gauge_assigned' | 'report_set_switched' | 'quote_cta_click';

export function track(event: Event, params: Record<string, unknown> = {}) {
  (window as unknown as { dgTrack?: (e: string, p: object) => void }).dgTrack?.(event, params);
}
